module.exports = __webpack_public_path__ + "img/icon-music.710fbe11.svg";